/**
 * Public licensing / compliance copy from env (Phase F).
 * Company NMLS defaults to the registered Unbeatable Loans ID; override via env if needed.
 */
/** Unbeatable Loans — Nationwide Mortgage Licensing System company identifier */
export const DEFAULT_COMPANY_NMLS = '1827883';

export type LicensingPublicConfig = {
  companyNmls: string;
  mloNmlsLine: string;
  additionalDisclosures: string;
  complianceReviewedAt: string;
};

function trim(s: string | undefined): string {
  return s?.trim() ?? '';
}

export function getLicensingPublicConfig(): LicensingPublicConfig {
  const fromEnv = trim(import.meta.env.VITE_LICENSING_COMPANY_NMLS);
  return {
    companyNmls: fromEnv || DEFAULT_COMPANY_NMLS,
    mloNmlsLine: trim(import.meta.env.VITE_LICENSING_MLO_LINE),
    additionalDisclosures: trim(
      import.meta.env.VITE_LICENSING_ADDITIONAL_DISCLOSURES
    ),
    complianceReviewedAt: trim(
      import.meta.env.VITE_LICENSING_COMPLIANCE_REVIEWED
    ),
  };
}

export function hasPublishedNmlsNumbers(): boolean {
  const c = getLicensingPublicConfig();
  return Boolean(c.companyNmls || c.mloNmlsLine);
}
